import { api_domain } from '../../config'
import axios from 'axios'

const url = `${api_domain}api/cc`
const cc = {
    get(){
        return axios({
            url: url,
            method:'GET',
        }).catch((e)=>{
            console.log('Catch error on get-cc\n', e.message)
            return { status: e.response.status }           
        })
    }
}

export default cc